import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { schemaHasAttributes } from 'criteria-entity-model';
import { AttributeList } from '../../attribute-list';
import { Heading } from '../../markdown';
import { SchemaDescription } from './SchemaDescription';
import { SchemaEnumValues } from './SchemaEnumValues';
import { SchemaOverviewSection } from './SchemaOverviewSection';
import { SchemaValidationBadges } from './SchemaValidationBadges';
export function SchemaView({ schema, page }) {
    if (typeof schema === 'boolean') {
        return (_jsx("div", { className: "rounded-lg border border-zinc-950/10 bg-transparent bg-zinc-50 dark:border-white/20 dark:bg-white/5", children: _jsxs("p", { className: "p-2 text-xs", children: [schema && _jsx("span", { children: "any data" }), !schema && _jsx("span", { children: "no data" })] }) }));
    }
    if (typeof schema !== 'object' || schema === null) {
        return null;
    }
    if (!schemaHasAttributes(schema)) {
        return (_jsx("div", { className: "rounded-lg border border-zinc-950/10 bg-transparent bg-zinc-50 dark:border-white/20 dark:bg-white/5", children: _jsxs("div", { className: "space-y-2 px-2 py-2", children: [_jsx(SchemaValidationBadges, { schema: schema }), _jsx(SchemaDescription, { schema: schema }), _jsx(SchemaEnumValues, { schema: schema })] }) }));
    }
    return (_jsxs("div", { className: "space-y-2", children: [page && _jsx(SchemaOverviewSection, { schema: schema }), _jsxs("div", { className: clsx(page
                    ? ''
                    : 'rounded-lg border border-zinc-950/10 bg-transparent bg-zinc-50 [--gutter:theme(spacing.2)] dark:border-white/20 dark:bg-white/5'), children: [page && _jsx(Heading, { level: 1, children: "Attributes" }), _jsx(AttributeList, { schema: schema, parents: [] })] })] }));
}
